var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.getTitle())+" ")]),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[(this.actionLocal)?_c('UserForm',{attrs:{"action":_vm.actionLocal,"user":_vm.userLocal}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }